var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bottom"},[_c('div',{staticClass:"site-info"},[_vm._v(" 指导单位：国务院扶贫办社会扶贫司、国务院扶贫办信息中心 京ICP备："+_vm._s(_vm.copyRight.icp)+" 中国社会扶贫网 版权所有 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }